// Модуль для обработки выбора самовывоза и вывода адреса в форму

// Функция для установки адреса самовывоза в форму
function setPickupAddressToForm() {
    const deliveryAddressBlock = document.querySelector('.delivery__address');
    const orderForm = document.querySelector('#order-form');
    
    if (!deliveryAddressBlock || !orderForm) {
        console.log('❌ Элементы формы не найдены');
        return;
    }
    
    // Получаем текст из dropdown__header__text третьего item-delivery
    const thirdItemDelivery = document.querySelector('.item-delivery:nth-child(3)');
    let pickupAddressText = 'Самовывоз из магазина MHAND'; // значение по умолчанию
    
    if (thirdItemDelivery) {
        const dropdownHeaderText = thirdItemDelivery.querySelector('.dropdown__header__text');
        if (dropdownHeaderText) {
            // Убираем SVG иконку и получаем только текст
            const textContent = dropdownHeaderText.textContent.trim();
            if (textContent && textContent !== 'Добавить адрес доставки') {
                pickupAddressText = textContent;
            }
        }
    }
    
    const pickupCity = 'Москва'; // или другой город по умолчанию
    
    // Устанавливаем адрес в блок доставки
    deliveryAddressBlock.innerHTML = `Адрес доставки: ${pickupCity}<br>Самовывоз: ${pickupAddressText}`;
    
    // Обновляем данные формы
    orderForm.dataset.city_name = pickupCity;
    orderForm.dataset.pickup_address = pickupAddressText;
    
    console.log('✅ Адрес самовывоза установлен в форму:', pickupAddressText);
}

// Функция для обработки выбора самовывоза
function handlePickupSelection() {
    const pickupRadio = document.querySelector('#delivery-way-3');
    const thirdItemDelivery = document.querySelector('.item-delivery:nth-child(3)');
    const deliveryAddressBlock = document.querySelector('.delivery__address');
    
    if (!pickupRadio || !deliveryAddressBlock) {
        console.log('❌ Элементы самовывоза не найдены');
        return;
    }
    
    // Добавляем обработчик события на radio button
    pickupRadio.addEventListener('change', function() {
        if (this.checked) {
            console.log('🎯 Выбран самовывоз из магазина MHAND');
            setPickupAddressToForm();
            
            // Пересчитываем цену доставки (для самовывоза обычно 0)
            if (window.calculateOrderPrice) {
                window.calculateOrderPrice('Москва', 'pickup');
            }
            
            // Запускаем валидацию формы
            if (window.dispatchOrderValidate) {
                window.dispatchOrderValidate();
            }
        }
    });
    
    // Добавляем обработчик клика на весь item-delivery
    if (thirdItemDelivery) {
        thirdItemDelivery.addEventListener('click', function(e) {
            // Проверяем, что клик не на radio button (чтобы избежать двойного срабатывания)
            if (!e.target.closest('input[type="radio"]')) {
                console.log('🎯 Клик на item-delivery 3 (самовывоз)');
                
                // Устанавливаем radio button как выбранный
                pickupRadio.checked = true;
                
                // Устанавливаем адрес в форму
                setPickupAddressToForm();
                
                // Пересчитываем цену доставки
                if (window.calculateOrderPrice) {
                    window.calculateOrderPrice('Москва', 'pickup');
                }
                
                // Запускаем валидацию формы
                if (window.dispatchOrderValidate) {
                    window.dispatchOrderValidate();
                }
            }
        });
    }
    
    console.log('✅ Обработчики выбора самовывоза инициализированы');
}

// Функция для инициализации обработчиков самовывоза
function initPickupAddressHandlers() {
    handlePickupSelection();
    
    // Проверяем, если самовывоз уже выбран при загрузке
    const pickupRadio = document.querySelector('#delivery-way-3');
    if (pickupRadio && pickupRadio.checked) {
        console.log('🎯 Самовывоз уже выбран при загрузке');
        setPickupAddressToForm();
    }
    
    console.log('✅ Обработчики адреса самовывоза инициализированы');
}

// Функция для принудительной установки адреса самовывоза
function forceSetPickupAddress() {
    console.log('🧪 Принудительно устанавливаем адрес самовывоза...');
    setPickupAddressToForm();
    
    // Пересчитываем цену
    if (window.calculateOrderPrice) {
        window.calculateOrderPrice('Москва', 'pickup');
    }
    
    // Валидируем форму
    if (window.dispatchOrderValidate) {
        window.dispatchOrderValidate();
    }
}

// Экспортируем функции
export {
    setPickupAddressToForm,
    handlePickupSelection,
    initPickupAddressHandlers,
    forceSetPickupAddress
};

// Экспортируем в глобальную область для использования в других модулях
window.setPickupAddressToForm = setPickupAddressToForm;
window.handlePickupSelection = handlePickupSelection;
window.forceSetPickupAddress = forceSetPickupAddress;

// Инициализация при загрузке страницы
document.addEventListener('DOMContentLoaded', function() {
    // Ждем немного, чтобы все элементы загрузились
    setTimeout(() => {
        initPickupAddressHandlers();
    }, 100);
}); 